import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { FieldStyledBadgeLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledBadgeLabel';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';
import { FieldVariableLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldVariableLabel';

defineBlock({
    type: 'var_set_bool',
    colour: '#da00bd',
    tooltip: '真偽値変数に値を代入します',
    movable: true,
    deletable: true,
    previousStatement: true,
    nextStatement: true,
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/var_bool.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () =>
                        new FieldStyledLabel('変数セット', {
                            fontSize: 12,
                            fontWeight: 'bold',
                        }),
                },
                {
                    type: 'field',
                    instance: () => new FieldStyledBadgeLabel('真偽'),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'field',
                    name: 'VAR_LABEL',
                    instance: () => new FieldVariableLabel('設定する変数', { fontWeight: 'normal', varType: 'bool' }),
                },
                { type: 'label', text: 'に' },
            ],
        },
        {
            kind: 'value',
            name: 'VALUE',
            check: 'Boolean',
            shadow: { type: 'bool', fields: { BOOL: 'TRUE' } },
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: 'を入れる ' }],
        },
    ],
});
